export default "__VITE_ASSET__BsrxvdJf__"